module.exports = __webpack_public_path__ + "img/section_round_2.60a53212.svg";